module.exports = __webpack_public_path__ + "static/media/climap.e5c3d4d2.png";